import gql from 'graphql-tag';

const queryName = 'roles';

export const GET_ROLES = {
  queryName,
  queryBody: gql`
  query ${queryName} {
    ${queryName} {
      roles {
        id
        name
      }
    }
  }
  `,
};
